exports["ES"] = require("./ES.js");
exports["UK"] = require("./UK.js");